/** 购买支付接口：建单、支付参数、模拟支付、订单查询 */
import request from '@/utils/request';

const PAYMENT_API = '/api/user/api/payment';

export function createOrder({ years, channel, agreementId, orderType }) {
  const params = { years, channel, agreementId };
  if (orderType != null) {
    params.orderType = orderType;
  }
  return request.post(`${PAYMENT_API}/order/create`, null, { params });
}

export function fetchPayParams({ orderNo, channel, qrmode, qrwidth }) {
  return request.get(`${PAYMENT_API}/pay_params`, {
    params: { orderNo, channel, qrmode, qrwidth },
  });
}

export function simulatePay(orderNo) {
  return request.post(`${PAYMENT_API}/simulate_pay`, null, {
    params: { orderNo },
  });
}

export function fetchOrderQuery(orderNo) {
  return request.get(`${PAYMENT_API}/order/query`, {
    params: { orderNo },
  });
}



// WEBPACK FOOTER //
// ./src/view/user/purchaseService/api.js